/**
 * Permisos requeridos por pantalla (nombre de ruta → permisos, basta UNO).
 * Espejo del mapeo del backend (CheckModulePermission): el backend es quien
 * bloquea de verdad; esto evita mostrar pantallas que responderían 403.
 * Rutas sin entrada no exigen permiso (perfil personal, planes, soporte…).
 */

const ANY_SALES_DOC = [
  "invoices.view",
  "quotes.view",
  "credit_notes.view",
  "debit_notes.view",
  "withholdings.view",
  "liquidations.view",
  "remissions.view",
  "payments.view"
];

const BY_NAME = {
  "sales.documents": ANY_SALES_DOC,
  "sales.expenses": ["expenses.view"],

  "sales.quotes.add": ["quotes.create"],
  "sales.quotes.view": ["quotes.view"],
  "sales.quotes.edit": ["quotes.edit"],

  "sales.invoices.add": ["invoices.create"],
  "sales.invoices.view": ["invoices.view"],
  "sales.invoices.api.view": ["invoices.view"],
  "sales.invoices.edit": ["invoices.edit"],

  "sales.liquidations.add": ["liquidations.create"],
  "sales.liquidations.view": ["liquidations.view"],
  "sales.liquidations.edit": ["liquidations.create"],

  "sales.creditNote.add": ["credit_notes.create"],
  "sales.creditNote.view": ["credit_notes.view"],
  "sales.creditNote.edit": ["credit_notes.create"],

  "sales.debitNote.add": ["debit_notes.create"],
  "sales.debitNote.view": ["debit_notes.view"],
  "sales.debitNote.edit": ["debit_notes.create"],

  "sales.withholdings.add": ["withholdings.create"],
  "sales.withholdings.view": ["withholdings.view"],
  "sales.withholdings.edit": ["withholdings.create"],

  "sales.payments.view": ["payments.view"],

  "sales.remissions.add": ["remissions.manage"],
  "sales.remissions.view": ["remissions.view"],
  "sales.remissions.edit": ["remissions.manage"],

  wallet: ["wallet.view"],

  "catalogue.products": ["products.view", "products.manage", "inventory.view"],
  "catalogue.products.add": ["products.manage"],
  "catalogue.products.edit": ["products.manage"],
  "catalogue.categories": ["products.view", "categories.manage"],
  "catalogue.categories.add": ["categories.manage"],
  "catalogue.categories.edit": ["categories.manage"],
  "catalogue.movements": ["inventory.view", "products.manage"],
  "catalogue.movements.view": ["inventory.view", "products.manage"],
  "catalogue.attributes": ["products.manage"],

  "business.main": ["clients.view", "clients.manage"],
  "business.add": ["clients.manage"],
  "business.edit": ["clients.manage"],

  agreements: ["contracts.view"],
  "agreements.edit": ["contracts.manage"],
  "agreements.templates": ["contracts.manage"],

  documentos: ["documents.view"],
  "documentos.new": ["documents.sign"],
  "documentos.sign-flow": ["documents.sign"],
  "documentos.edit": ["documents.sign"],
  "documentos.pdf-edit": ["documents.sign"],
  "documentos.detail": ["documents.view"],

  "profile.trade": ["business.profile"],
  configurations: ["settings.view", "settings.manage", "templates.manage"],

  reports: ["reports.view"],
  "reports.dashboard": ["reports.view"],

  team: ["team.view", "team.manage"],
  projects: ["invoices.view", "quotes.view"]
};

export function permissionsForRoute(name) {
  return BY_NAME[name] || null;
}

export { ANY_SALES_DOC };
